/**
 * Cart drawer extras: gift accordion + FBT scroll reset.
 *
 * Loaded once (defer). Uses event delegation + MutationObserver so the
 * behaviour survives cart drawer section morphs — the previous inline
 * <script> was re-injected with every morph and could double-register
 * document-level listeners.
 */
(function () {
  if (window.__cartDrawerExtrasInit) return;
  window.__cartDrawerExtrasInit = true;

  function readConfig() {
    var el = document.getElementById('cart-drawer-extras-config');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  // FBT accordion: reset drawer scroll when opened.
  // Delegated with capture because `toggle` does not bubble.
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (
        details instanceof HTMLElement &&
        details.classList.contains('cart-drawer__fbt') &&
        /** @type {HTMLDetailsElement} */ (details).open
      ) {
        var content = document.querySelector('.cart-drawer__content');
        if (content) content.scrollTop = 0;
      }
    },
    true
  );

  var giftOpen = false;
  var chevronSVG =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';

  function buildGiftAccordion() {
    var cfg = readConfig();
    if (!cfg.giftActive) return;
    var picker = document.querySelector('.cart-drawer .offer-gift-picker');
    if (!picker || picker.querySelector('.cart-drawer__gift-wrap')) return;
    var carousel = picker.querySelector('.offer-gift-picker__carousel');
    if (!carousel) return;

    var wrap = document.createElement('div');
    wrap.className = 'cart-drawer__gift-wrap' + (giftOpen ? ' cart-drawer__gift-wrap--open' : '');
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cart-drawer__gift-toggle';
    var label = document.createElement('span');
    label.className = 'cart-drawer__gift-label';
    label.textContent = giftOpen ? cfg.giftHide : cfg.giftShow;
    var chevron = document.createElement('span');
    chevron.className = 'cart-drawer__gift-chevron';
    chevron.innerHTML = chevronSVG;
    button.appendChild(label);
    button.appendChild(chevron);
    var carouselWrap = document.createElement('div');
    carouselWrap.className = 'cart-drawer__gift-carousel-wrap';
    carousel.parentNode.insertBefore(wrap, carousel);
    carouselWrap.appendChild(carousel);
    wrap.appendChild(button);
    wrap.appendChild(carouselWrap);
    button.addEventListener('click', function () {
      giftOpen = !giftOpen;
      wrap.classList.toggle('cart-drawer__gift-wrap--open', giftOpen);
      label.textContent = giftOpen ? cfg.giftHide : cfg.giftShow;
    });
  }

  var tid = 0;
  function scheduleGiftBuild() {
    clearTimeout(tid);
    tid = setTimeout(buildGiftAccordion, 80);
  }

  function boot() {
    var cfg = readConfig();
    if (!cfg.giftActive) return;
    var component = document.querySelector('cart-drawer-component');
    if (component) {
      new MutationObserver(scheduleGiftBuild).observe(component, { childList: true, subtree: true });
    }
    ['shopify:section:load', 'cart:change', 'cart:update'].forEach(function (name) {
      document.addEventListener(name, scheduleGiftBuild);
    });
    buildGiftAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
